import React from 'react'
    import { ArrowRight, Star, Users, Zap, Shield } from 'lucide-react'
    import { Link } from 'react-router-dom'

    const Home = () => {
      const features = [
        {
          icon: <Zap className="h-8 w-8 text-yellow-500" />,
          title: 'Lightning Fast',
          description: 'Built with modern technology for optimal performance and speed.'
        },
        {
          icon: <Shield className="h-8 w-8 text-green-500" />,
          title: 'Secure & Reliable',
          description: 'Enterprise-grade security with 99.9% uptime guarantee.'
        },
        {
          icon: <Users className="h-8 w-8 text-blue-500" />,
          title: 'User Friendly',
          description: 'Intuitive design that puts user experience at the forefront.'
        },
        {
          icon: <Star className="h-8 w-8 text-purple-500" />,
          title: 'Premium Quality',
          description: 'Crafted with attention to detail and industry best practices.'
        }
      ]

      return (
        <div className="min-h-screen" data-component-path="client/src/pages/Home.jsx" data-component-line="1:4" data-component-id="client/src/pages/Home.jsx:1:4">
          {/* Hero Section */}
          <section 
            className="relative h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2074&q=80)'
            }}
            data-component-path="client/src/pages/Home.jsx" data-component-line="2:6" data-component-id="client/src/pages/Home.jsx:2:6"
          >
            <div className="absolute inset-0 bg-black bg-opacity-50" data-component-path="client/src/pages/Home.jsx" data-component-line="3:8" data-component-id="client/src/pages/Home.jsx:3:8"></div>
            <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-4" data-component-path="client/src/pages/Home.jsx" data-component-line="4:8" data-component-id="client/src/pages/Home.jsx:4:8">
              <h1 className="text-5xl md:text-7xl font-bold mb-6 animate-fade-in" data-component-path="client/src/pages/Home.jsx" data-component-line="5:10" data-component-id="client/src/pages/Home.jsx:5:10">
                Welcome to the Future
              </h1>
              <p className="text-xl md:text-2xl mb-8 text-gray-200 animate-fade-in" data-component-path="client/src/pages/Home.jsx" data-component-line="6:10" data-component-id="client/src/pages/Home.jsx:6:10">
                Experience cutting-edge technology with beautiful design and exceptional performance
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in" data-component-path="client/src/pages/Home.jsx" data-component-line="7:10" data-component-id="client/src/pages/Home.jsx:7:10">
                <Link 
                  to="/about"
                  className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors duration-200 flex items-center justify-center space-x-2"
                  data-component-path="client/src/pages/Home.jsx" data-component-line="8:12" data-component-id="client/src/pages/Home.jsx:8:12"
                >
                  <span data-component-path="client/src/pages/Home.jsx" data-component-line="9:14" data-component-id="client/src/pages/Home.jsx:9:14">Get Started</span>
                  <ArrowRight className="h-5 w-5" data-component-path="client/src/pages/Home.jsx" data-component-line="10:14" data-component-id="client/src/pages/Home.jsx:10:14" />
                </Link>
                <Link 
                  to="/contact"
                  className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg font-semibold transition-all duration-200"
                  data-component-path="client/src/pages/Home.jsx" data-component-line="11:12" data-component-id="client/src/pages/Home.jsx:11:12"
                >
                  Learn More
                </Link>
              </div>
            </div>
          </section>

          {/* Features Section */}
          <section className="py-20 bg-white" data-component-path="client/src/pages/Home.jsx" data-component-line="12:6" data-component-id="client/src/pages/Home.jsx:12:6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Home.jsx" data-component-line="13:8" data-component-id="client/src/pages/Home.jsx:13:8">
              <div className="text-center mb-16" data-component-path="client/src/pages/Home.jsx" data-component-line="14:10" data-component-id="client/src/pages/Home.jsx:14:10">
                <h2 className="text-4xl font-bold text-gray-900 mb-4" data-component-path="client/src/pages/Home.jsx" data-component-line="15:12" data-component-id="client/src/pages/Home.jsx:15:12">Why Choose Us?</h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-component-path="client/src/pages/Home.jsx" data-component-line="16:12" data-component-id="client/src/pages/Home.jsx:16:12">
                  We combine innovation with reliability to deliver exceptional solutions that exceed expectations
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-component-path="client/src/pages/Home.jsx" data-component-line="17:10" data-component-id="client/src/pages/Home.jsx:17:10">
                {features.map((feature, index) => (
                  <div 
                    key={index}
                    className="text-center p-6 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors duration-200 animate-slide-in"
                    data-component-path="client/src/pages/Home.jsx" data-component-line="18:12" data-component-id="client/src/pages/Home.jsx:18:12"
                  >
                    <div className="flex justify-center mb-4" data-component-path="client/src/pages/Home.jsx" data-component-line="19:14" data-component-id="client/src/pages/Home.jsx:19:14">
                      {feature.icon}
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2" data-component-path="client/src/pages/Home.jsx" data-component-line="20:14" data-component-id="client/src/pages/Home.jsx:20:14">{feature.title}</h3>
                    <p className="text-gray-600" data-component-path="client/src/pages/Home.jsx" data-component-line="21:14" data-component-id="client/src/pages/Home.jsx:21:14">{feature.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="py-20 bg-blue-600" data-component-path="client/src/pages/Home.jsx" data-component-line="22:6" data-component-id="client/src/pages/Home.jsx:22:6">
            <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Home.jsx" data-component-line="23:8" data-component-id="client/src/pages/Home.jsx:23:8">
              <h2 className="text-4xl font-bold text-white mb-4" data-component-path="client/src/pages/Home.jsx" data-component-line="24:10" data-component-id="client/src/pages/Home.jsx:24:10">Ready to Get Started?</h2>
              <p className="text-xl text-blue-100 mb-8" data-component-path="client/src/pages/Home.jsx" data-component-line="25:10" data-component-id="client/src/pages/Home.jsx:25:10">
                Join thousands of satisfied users who have transformed their workflow with our platform
              </p>
              <Link 
                to="/contact"
                className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold transition-colors duration-200 inline-flex items-center space-x-2"
                data-component-path="client/src/pages/Home.jsx" data-component-line="26:10" data-component-id="client/src/pages/Home.jsx:26:10"
              >
                <span data-component-path="client/src/pages/Home.jsx" data-component-line="27:12" data-component-id="client/src/pages/Home.jsx:27:12">Contact Us Today</span>
                <ArrowRight className="h-5 w-5" data-component-path="client/src/pages/Home.jsx" data-component-line="28:12" data-component-id="client/src/pages/Home.jsx:28:12" />
              </Link>
            </div>
          </section>
        </div>
      )
    }

    export default Home